import { useGetRegionalPaymentStatisticsQuery } from '@/api/ariadne/__generated_types__/apollo';
import * as userSelectors from '@/user/user-selectors';
import { useSelector } from 'react-redux';
import { PaymentPeriodDateRange } from '../types';

export function useRegionalPaymentStatistics(args: {
  period: PaymentPeriodDateRange;
}) {
  const regionId: string = useSelector(userSelectors.currentCity);

  const { data, loading: isLoadingRegionalStatistics } =
    useGetRegionalPaymentStatisticsQuery({
      variables: {
        regionId,
        filters: { period: args.period },
      },
    });

  return {
    regionalStatistics: data?.region.taxSummary,
    isLoadingRegionalStatistics,
  };
}
